import React, { useState } from "react";
import CardTable from "../../../components/AdminTable/CardTable";
import Dropdown from "../../../components/AdminDropdown/Dropdown";

function ViewItem() {
  const [columns] = useState([
    {
      header: "SN",
      accessorKey: "SN",

    },
    {
      header: "User",
      accessorKey: "User",
    },
    {
      header: "Category",
      accessorKey: "Category",
    },
    {
      header: "Quantity",
      accessorKey: "Quantity",
    },
    {
      header: "	Start Date",
      accessorKey: "Start",
    },
    {
      header: "	Expiry date (MM/YY)",
      accessorKey: "Expirydate",
    },
    {
      header: "Actions",
      accessorKey: "total",
      cell: (row) => <Dropdown />,
    },

  ]);
  const [data] = useState([
    {
      SN: '1',
      Category: 'Sandwich',
      Quantity: '2023-10-01',
      Start: "2023 - 10 - 25",
      Expirydate: "20"
    }

  ]);


  return (
    <main>
      <CardTable
        data={data}
        columns={columns}
        heading={"Assign Item Category"}



      />
    </main>
  );
}

export default ViewItem;
